/* Hoofdmenu: paneel opent bij hover (alleen desktop met muis); klik op het woord gaat naar de eigen pagina.
   Sluit weer bij verlaten, scrollen en Escape. Zonder dit script werkt het menu zoals voorheen met een klik. */
(function () {
  var mq = window.matchMedia('(min-width: 990px) and (hover: hover)');

  function setup(d) {
    var wrap = d.closest('li') || d;
    var summary = d.querySelector('summary');
    var openT, closeT;

    function set(on) {
      if (on) d.setAttribute('open', ''); else d.removeAttribute('open');
      if (summary) summary.setAttribute('aria-expanded', on ? 'true' : 'false');
    }

    wrap.addEventListener('mouseenter', function () {
      if (!mq.matches) return;
      clearTimeout(closeT);
      clearTimeout(openT);
      openT = setTimeout(function () {
        document.querySelectorAll('.header__inline-menu details[open]').forEach(function (o) {
          if (o !== d) o.removeAttribute('open');
        });
        set(true);
      }, 120);
    });

    wrap.addEventListener('mouseleave', function () {
      if (!mq.matches) return;
      clearTimeout(openT);
      closeT = setTimeout(function () { set(false); }, 180);
    });

    window.addEventListener('scroll', function () {
      if (mq.matches && d.open) set(false);
    }, { passive: true });
  }

  function init() {
    document.querySelectorAll('.header__inline-menu details.sf-ml').forEach(setup);
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.header__inline-menu details.sf-ml[open]').forEach(function (o) { o.removeAttribute('open'); });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
